import styled from "./StudentProfile.module.css"
import Navbar from "../../../../components/navbar/Navbar"
import { Link } from "react-router-dom"
import StudentProfileEditor from "./StudentProfileEditor" 
import { useTranslation } from 'react-i18next'
const StudentProfile = () => {
    const { t } = useTranslation()
    return (
      <>
      <Navbar />
      <div className={styled.container}>
           <div className={styled.personalInfo}>
            <div className={styled.leftSide}>
            <StudentProfileEditor />
            </div>
            <div className={styled.rightSide}>
              <h2>{t('StudentProfile.generalInfo')}</h2>
              <div className={styled.lists}>
              <li> <Link to="/completed-lessons">{t('StudentProfile.completedLessons')}</Link> </li>
              <li><Link to="/awaiting-lessons">{t('StudentProfile.awaitingLessons')}</Link></li>
              <li><Link to={"/todays-lessons"} className={styled.tdLessons}> {t('StudentProfile.todaysLessons')}</Link></li> 
              </div>
            </div>
           </div>
      </div>
      </>
    )
}

export default StudentProfile